import { nodeHeight, nodeWidth, type GraphEdge, type GraphNode, type NodeDefBase } from './nodeDefs.js';

export function autoPlaceNodes(nodes: GraphNode[], edges: GraphEdge[], defs: Record<string, NodeDefBase>): void {
  const GAP_X = 60;
  const GAP_Y = 24;
  const PAD_X = 24;
  const PAD_Y = 24;

  const ids = nodes.map(node => node.id);
  const col: Record<string, number> = {};
  const adj: Record<string, string[]> = {};
  const inDeg: Record<string, number> = {};

  ids.forEach(id => {
    col[id] = 0;
    adj[id] = [];
    inDeg[id] = 0;
  });

  edges.forEach(edge => {
    if (adj[edge.fromNode]) adj[edge.fromNode].push(edge.toNode);
    if (inDeg[edge.toNode] !== undefined) inDeg[edge.toNode]++;
  });

  const queue = ids.filter(id => inDeg[id] === 0);
  const sorted: string[] = [];
  while (queue.length) {
    const id = queue.shift()!;
    sorted.push(id);
    adj[id].forEach(nextId => {
      inDeg[nextId]--;
      if (inDeg[nextId] === 0) queue.push(nextId);
    });
  }

  sorted.forEach(id => {
    adj[id].forEach(nextId => {
      col[nextId] = Math.max(col[nextId], col[id] + 1);
    });
  });

  const layers: Record<number, GraphNode[]> = {};
  nodes.forEach(node => {
    const layerIndex = col[node.id] || 0;
    (layers[layerIndex] = layers[layerIndex] || []).push(node);
  });
  Object.values(layers).forEach(layer => layer.sort((a, b) => a.y - b.y));

  const numCols = Math.max(...Object.keys(layers).map(Number)) + 1;
  const colX: number[] = Array(numCols).fill(0);
  colX[0] = PAD_X;
  for (let colIndex = 1; colIndex < numCols; colIndex++) {
    const prevLayer = layers[colIndex - 1] || [];
    const prevMaxW = Math.max(160, ...prevLayer.map(node => nodeWidth(node, defs)));
    colX[colIndex] = colX[colIndex - 1] + prevMaxW + GAP_X;
  }

  Object.entries(layers).forEach(([colIndex, layer]) => {
    let y = PAD_Y;
    layer.forEach(node => {
      node.x = colX[parseInt(colIndex)];
      node.y = y;
      y += nodeHeight(node, defs) + GAP_Y;
    });
  });
}
